import script from "./OrderAddBill.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderAddBill.vue?vue&type=script&setup=true&lang=js"

import "./OrderAddBill.vue?vue&type=style&index=0&id=7c1b780c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c1b780c"]])

export default __exports__